/**
 * Right-sized local copies of images whose S3 originals are far bigger than
 * the page ever shows them.
 *
 * Why: the browser has to decode an image at its full size before it can draw
 * it, however small it appears. The home page fleet cards show each car at
 * 230px wide, but the originals are 2400-2500px PNGs (~1.8 MB each) and the
 * GranLuxe one is a 13650 x 7200 AVIF (~390 MB once decoded). Decoding those
 * while they scroll into view is what made the page stutter.
 *
 * The originals on S3 (and the URLs stored in the database) are unchanged;
 * the page simply swaps in these copies when it recognises the URL. A URL
 * that isn't listed here is used as-is.
 *
 * To add one: export a copy at ~3x its largest on-screen width (sharp on
 * high-density phones), put it in src/assets/images, and map its S3 URL here.
 */
import alphardCard from "../assets/images/fleet/Alphard-690.webp";
import granAceCard from "../assets/images/fleet/Granace-690.webp";
import hiAceLuxuryCabinCard from "../assets/images/fleet/LuxuryCabin-690.webp";
import benzVClassCard from "../assets/images/fleet/BenzVClass-690.webp";
import benzSClassCard from "../assets/images/fleet/BenzSClass-690.webp";
import granLuxeCard from "../assets/images/granluxe/granluxe-hero-960.avif";
import wellCabinBanner1600 from "../assets/images/well-cabin/well-cabin-banner-1600.avif";
import wellCabinBanner2400 from "../assets/images/well-cabin/well-cabin-banner-2400.avif";
import wellCabinBanner3200 from "../assets/images/well-cabin/well-cabin-banner-3200.avif";

const S3_BUCKET_URL = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com";

// S3 original -> local copy sized for a fleet card (shown at up to 230px).
const VEHICLE_CARD_IMAGES = {
  [`${S3_BUCKET_URL}/public_folder/fleet/Alphard/no-bg-new.png`]: alphardCard,
  [`${S3_BUCKET_URL}/public_folder/fleet/Granace/no-bg-new.png`]: granAceCard,
  [`${S3_BUCKET_URL}/public_folder/fleet/LuxuryCabin/no-bg-new.png`]: hiAceLuxuryCabinCard,
  [`${S3_BUCKET_URL}/public_folder/fleet/BenzVClass/no-bg-new.png`]: benzVClassCard,
  [`${S3_BUCKET_URL}/public_folder/fleet/BenzSClass/no-bg-new.png`]: benzSClassCard,
  [`${S3_BUCKET_URL}/revamp_ui_assets/images/avif-type/new-image-granluxe.avif`]: granLuxeCard,
};

/** The card-sized copy of a vehicle picture, or the original URL if we have none. */
export const getVehicleCardImage = (originalUrl) => VEHICLE_CARD_IMAGES[originalUrl] || originalUrl;

/**
 * The WELL Cabin banner on the home page (full width, up to 1920px). The
 * browser picks the smallest file that is still sharp for the screen.
 * Original: 9504 x 6336.
 */
export const WELL_CABIN_BANNER = {
  src: wellCabinBanner2400,
  srcSet: `${wellCabinBanner1600} 1600w, ${wellCabinBanner2400} 2400w, ${wellCabinBanner3200} 3200w`,
  sizes: "(min-width: 1920px) 1920px, 100vw",
};
